import { TimePicker as AntTimePicker } from "antd";
import dayjs, { type Dayjs } from "dayjs";
import type { FC } from "react";

import type { AntCustomFormField, TimePickerAttributes } from "../../types/types";

interface TimePickerProps extends AntCustomFormField<string>, TimePickerAttributes {
    name: string;
    label: string;
    readOnly: boolean;
    placeholder?: string;
}

export const TimePicker: FC<TimePickerProps> = ({ defaultValue, onChange, value, format, readOnly, ...restProps }) => {
    const onValueChange = (newValue: Dayjs | null) => {
        if (onChange && newValue) {
            onChange(newValue.format());
        }
    };

    return (
        <AntTimePicker
            changeOnScroll
            defaultValue={typeof defaultValue === "string" ? dayjs(defaultValue) : undefined}
            value={value ? dayjs(value) : undefined}
            format={format || "HH:mm:ss"}
            disabled={readOnly}
            onChange={onValueChange}
            {...restProps}
            size="large"
        />
    );
};
